import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import DataTable, { MUIDataTableOptions } from "mui-datatables";
import * as Dati from "../../../Dati";
import { _TableLoader } from "..";
import { GetClientsListColumns } from "./ClientsListColumns";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    tableWrapper: {
        marginTop: spacing(4),
        position: "relative"
    }
}));

interface IClientsListTableProps {
    Data: Dati.CRisAPIPagineTipi_Anag | undefined;
    Options: MUIDataTableOptions;
    IsLoading: boolean;
}

export const _ClientsListTable: React.FC<IClientsListTableProps> = React.memo(({ Data, Options, IsLoading }) => {
    const classes = useStyles();

    return (
        <Box className={classes.tableWrapper}>
            {IsLoading && <_TableLoader />}
            <DataTable title="" data={Data?.Dati || []} columns={GetClientsListColumns()} options={Options} />
        </Box>
    );
});



// WEBPACK FOOTER //
// ./src/inar2/components/ClientsList/ClientsListTable.tsx